import googleTagManagerAdapter from 'gw-portals-tracking-js/adapters/GoogleTagManagerAdapter';

var configuration = {
    cookieDomain: 'auto'
};

var plugins = [];

export default {
    configure: function configure(config) {
        Object.assign(configuration, config);
        return this;
    },
    enablePlugin: function enablePlugin(pluginName) {
        plugins.push(pluginName);
        return this;
    },


    $get: ['$window', 'googleTagManager', function (window, gtm) {
        return googleTagManagerAdapter(window, gtm);
    }]
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-angular/adapters/googleTagManagerAdapterProvider.js
// module id = 913
// module chunks = 0